<template>
    <p>{{ $t('guide.guide_popover_step_4_desc') }}</p>
    <pt-button
        color="lightblue"
        :type="props.step.done ? 'outline' : 'contain'"
        @click="handleClick"
    >
        {{ $t('guide.guide_popover_step_4_btn_view') }}
    </pt-button>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import useEventBus from '@assets/plugins/eventBus';
import { usePtiUsage } from '@models/profile/usePtiUsage';
import { GuideStep } from '@master/store/guide.store';
import { useProfileInfo, Product } from '@models/profile/useCurrentProfile';
import type { Profile } from '@models/profile/profileList';
import useShowAuthDialog from '@master/hooks/service/useShowAuthDialog';

interface Props {
    step: GuideStep;
}

const props = defineProps<Props>();

const emit = defineEmits(['hide', 'show', 'trackEvent']);
const { eventBus } = useEventBus();
const { ptiModuleUsage } = usePtiUsage();
const { profileInfo, ptiProduct } = useProfileInfo();
const { checkAuth } = useShowAuthDialog();

// 档案有没有布玛
const isActived = computed(() => {
    return profileInfo.value?.isActived === 1;
});

function handleClick() {
    emit('hide');
    eventBus.$emit('hideVerifyDialog');
    eventBus.$emit('hideSetup');

    checkAuth(ptiProduct.value as Product, profileInfo.value as Profile, () => {
        if (!isActived.value) {
            eventBus.$emit('showTrackCodeDialog', 'startGuide_heatmap');
        } else {
            eventBus.$emit('openViewHeatmapDialog');
            emit('trackEvent', 'guide_hm_add_click', {
                has_completed: ptiModuleUsage.value?.['heatmap'] === 0 ? 0 : 1
            });
        }
    });
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.heatmap-code-dialog {
    width: 400px;
    height: 300px;
}
</style>
